import { IFrameMessagePayload } from "./iframe-message-payload";

export interface IFrameMessage {
    messageType: string;
    messageId: string;
    payload: IFrameMessagePayload;
}
